import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppLayout } from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Professionals from "@/pages/Professionals";
import Requests from "@/pages/Requests";
import Customers from "@/pages/Customers";
import Projects from "@/pages/Projects";
import Care from "@/pages/Care";
import Payments from "@/pages/Payments";
import Catalog from "@/pages/Catalog";
import AppContent from "@/pages/AppContent";
import Analytics from "@/pages/Analytics";
import ActivityFeed from "@/pages/ActivityFeed";
import Deployments from "@/pages/Deployments";
import OpenItems from "@/pages/OpenItems";
import FieldOnboarding from "@/pages/FieldOnboarding";
import Performance from "@/pages/Performance";
import Incentives from "@/pages/Incentives";
import SystemControl from "@/pages/SystemControl";
import DataExplorer from "@/pages/DataExplorer";
import Orders from "@/pages/Orders";
import PromisePage from "@/pages/Promise";
import Notifications from "@/pages/Notifications";
import SuperCrm from "@/pages/SuperCrm";
import Coupons from "@/pages/Coupons";
import Invoices from "@/pages/Invoices";
import SiteVisits from "@/pages/SiteVisits";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Routing() {
  const { user } = useAuth();
  const isField = user?.role === "field";
  const home = isField ? "/field/new-professional" : "/";
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={home} replace /> : <Login />} />
      <Route element={<Protected><AppLayout /></Protected>}>
        {isField ? (
          <Route path="/field/new-professional" element={<FieldOnboarding />} />
        ) : (
          <>
            <Route path="/" element={<Dashboard />} />
            <Route path="/activity" element={<ActivityFeed />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/professionals" element={<Professionals />} />
            <Route path="/pro-approvals" element={<Navigate to="/professionals?tab=approval" replace />} />
            <Route path="/field/new-professional" element={<FieldOnboarding />} />
            <Route path="/requests" element={<Requests />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/crm" element={<SuperCrm />} />
            <Route path="/visits" element={<SiteVisits />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/system" element={<SystemControl />} />
            <Route path="/data" element={<DataExplorer />} />
            <Route path="/incentives" element={<Incentives />} />
            <Route path="/care" element={<Care />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/promise" element={<PromisePage />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/coupons" element={<Coupons />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/content" element={<AppContent />} />
            <Route path="/deployments" element={<Deployments />} />
            <Route path="/open-items" element={<OpenItems />} />
            <Route path="/analytics" element={<Analytics />} />
          </>
        )}
      </Route>
      <Route path="*" element={<Navigate to={home} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routing />
        </BrowserRouter>
        <Toaster position="bottom-right" richColors theme="light" />
      </AuthProvider>
    </div>
  );
}

export default App;
